import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { SweetAlert, StorageHandler, DataHandler, APIHandler } from 'C4';

import { storageKeys } from 'settings';

const fastTrackData = (key, value = null) => {
  const data = JSON.parse(localStorage.getItem('fastTrackData')) || {};
  if (key && value === null) {
    if (data) return data[key];
    return null;
  }
  if (key && value) {
    data[key] = value;
    return localStorage.setItem('fastTrackData', JSON.stringify(data));
  }
  throw Error('Invalid input');
};

const leading = val => (`0${val}`).slice(-2);


const setProgressComplete = async () => {
  const { graduated } = await StorageHandler.load(storageKeys.user) || {};
  const fastTrackFinished = fastTrackData('finished');
  const fastTrackGrade = fastTrackData('grade') || 'F';


  if (!graduated && fastTrackFinished && fastTrackGrade !== 'F') {
    const appId = await DataHandler.matchAppId();
    const obj = await StorageHandler.load(storageKeys.user) || {};
    const d = new Date(Date.now());
    const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

    const { response: user } = obj;
    const newUser = obj;

    if (user) {
      const { email } = user;
      APIHandler.updateUser(appId, email, [
        { param: 'training_graduated', val: date },
      ]);

      newUser.training_graduated = date;
      StorageHandler.save(storageKeys.user, obj);

      const { data: [progress] } = await APIHandler.getUserProgress(appId, email);
      const { chapters } = progress;

      const progressUpdates = chapters.map(({ chapter: chapterId, total_pages: total }) => (
        APIHandler.setUserProgress({
          chapterId,
          lastPage: total,
          progress: total,
          email,
        })
      ));

      await Promise.all(progressUpdates);
      StorageHandler.remove(storageKeys.progress);
      window.location.reload();
    }
  }
};

export default class FastTrack extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appName: null,
    };
  }

  componentDidMount() {
    this.getAppName();
  }

  async getAppName() {
    const appId = await DataHandler.matchAppId();
    const { app: [{ appName }] } = await APIHandler.getAppInfo(appId) || { app: [{}] };

    this.setState({ appName });
  }

  render() {
    const {
      fastTrackCanceled,
      fastTrackErrors,
      fastTrackFinished,
      fastTrackGrade,
      hasFastTrack,
      onCancelAsk,
      onConfirmAsk,
      onConfirmGrade,
    } = this.props;
    const { appName } = this.state;

    const { grade, n } = fastTrackGrade;
    const gradeSwal = {
      title: i18n.translate('trainingScreens.grading', { grade, n }),
      text: 'Thank you for taking the quiz.',
      onClose: ({ value, dismiss }) => {
        if (value === true || dismiss) {
          onConfirmGrade();
          setProgressComplete();
        }
      },
      onOpen: () => {
        const startTime = fastTrackData('startTime');
        fastTrackData('totalTime', Math.floor((Date.now() - (startTime || 0)) / 1000));
      },
    };

    const startSwal = {
      title: i18n.translate('trainingScreens.fastTrack'),
      html: appName ? i18n.translate('trainingScreens.fastTrackExplanation', { appName }) : '',
      showCancelButton: true,
      cancelButtonText: i18n.translate('general.no'),
      confirmButtonText: i18n.translate('general.yes'),
      onClose: ({ dismiss, value }) => {
        if (value === true) {
          if (!fastTrackData('totalTime')) {
            fastTrackData('startTime', Date.now());
          }
          onConfirmAsk();
        }
        if (dismiss) {
          onCancelAsk();
        }
      },
    };

    return (
      <React.Fragment>
        {fastTrackGrade && (
          <SweetAlert
            trigger={fastTrackFinished === true && fastTrackErrors !== -1 && grade.length > 0}
            {...gradeSwal}
          />
        )}
      </React.Fragment>
    );
  }
}

FastTrack.propTypes = {
  fastTrackCanceled: PropTypes.bool,
  fastTrackErrors: PropTypes.number,
  fastTrackFinished: PropTypes.bool,
  fastTrackGrade: PropTypes.shape({
    grade: PropTypes.string,
    n: PropTypes.string,
  }),
  hasFastTrack: PropTypes.bool,
  onCancelAsk: PropTypes.func.isRequired,
  onConfirmAsk: PropTypes.func.isRequired,
  onConfirmGrade: PropTypes.func.isRequired,
};

FastTrack.defaultProps = {
  fastTrackCanceled: false,
  fastTrackErrors: 0,
  fastTrackFinished: false,
  fastTrackGrade: {
    grade: 'A+',
    n: 'n',
  },
  hasFastTrack: false,
};
